import { Directive, ElementRef, inject, OnInit } from '@angular/core';
import { App } from '@df/core/app';
import { Basket } from '@df/session/api/basket/basket';
import { Customer } from '@df/session/api/customer';
import { UiComponent } from '@df/ui/ui.component';

@Directive()
export abstract class AbstractBasketComponent extends UiComponent implements OnInit {
    readonly basket = inject(Basket);
    readonly app = inject(App);
    private customer = inject(Customer);
    protected elementRef = inject(ElementRef);

    override ngOnInit(): void {
        this.subscriptions.add(this.basket.subscribe(() => this.detectChanges()));
        super.ngOnInit();
    }
}
